import React from 'react';
import { BarChart3Icon, AlertCircleIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
export const DashboardPreview = () => {
  return <section id="dashboard" className="w-full bg-gray-50 py-16 md:py-24" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-52">
            Dein intelligentes Dashboard
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-53">
            Behalte den Überblick über offene Aufgaben, Aktivitäten und den
            Status deiner Buchhaltung.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-5xl mx-auto" data-id="element-54">
          <div className="bg-blue-600 text-white p-4" data-id="element-55">
            <div className="flex items-center justify-between" data-id="element-56">
              <h3 className="font-medium" data-id="element-57">TaxTidy Dashboard</h3>
              <div className="flex space-x-2" data-id="element-58">
                <div className="h-3 w-3 rounded-full bg-red-400" data-id="element-59"></div>
                <div className="h-3 w-3 rounded-full bg-yellow-400" data-id="element-60"></div>
                <div className="h-3 w-3 rounded-full bg-green-400" data-id="element-61"></div>
              </div>
            </div>
          </div>
          <div className="p-6" data-id="element-62">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-63">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-64">
                <div className="flex items-center justify-between mb-2" data-id="element-65">
                  <span className="text-gray-600 font-medium" data-id="element-66">
                    Offene Aufgaben
                  </span>
                  <AlertCircleIcon className="h-5 w-5 text-orange-500" data-id="element-67" />
                </div>
                <p className="text-2xl font-bold text-gray-900" data-id="element-68">7</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-69">
                <div className="flex items-center justify-between mb-2" data-id="element-70">
                  <span className="text-gray-600 font-medium" data-id="element-71">
                    Zugeordnete Belege
                  </span>
                  <CheckCircle2Icon className="h-5 w-5 text-green-500" data-id="element-72" />
                </div>
                <p className="text-2xl font-bold text-gray-900" data-id="element-73">124</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-74">
                <div className="flex items-center justify-between mb-2" data-id="element-75">
                  <span className="text-gray-600 font-medium" data-id="element-76">
                    Unzugeordnet
                  </span>
                  <ClockIcon className="h-5 w-5 text-blue-500" data-id="element-77" />
                </div>
                <p className="text-2xl font-bold text-gray-900" data-id="element-78">3</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-79">
                <div className="flex items-center justify-between mb-2" data-id="element-80">
                  <span className="text-gray-600 font-medium" data-id="element-81">KI-Score</span>
                  <BarChart3Icon className="h-5 w-5 text-purple-500" data-id="element-82" />
                </div>
                <p className="text-2xl font-bold text-gray-900" data-id="element-83">93%</p>
              </div>
            </div>
            <div className="mb-6" data-id="element-84">
              <h4 className="text-lg font-medium text-gray-900 mb-3" data-id="element-85">
                Letzte Aktivitäten
              </h4>
              <div className="space-y-3" data-id="element-86">
                {[{
                action: 'Beleg zugeordnet',
                item: 'Amazon Rechnung',
                time: 'vor 5 Min.',
                status: 'success'
              }, {
                action: 'Transaktion importiert',
                item: 'Sparkasse',
                time: 'vor 2 Std.',
                status: 'info'
              }, {
                action: 'Zuordnung benötigt',
                item: 'Tankstelle',
                time: 'vor 3 Std.',
                status: 'warning'
              }].map((activity, index) => <div key={index} className="flex items-center justify-between p-3 border-b border-gray-100" data-id="element-87">
                    <div className="flex items-center" data-id="element-88">
                      <div className={`h-2 w-2 rounded-full mr-3 ${activity.status === 'success' ? 'bg-green-500' : activity.status === 'warning' ? 'bg-orange-500' : 'bg-blue-500'}`} data-id="element-89"></div>
                      <div data-id="element-90">
                        <p className="text-gray-900" data-id="element-91">
                          {activity.action}:{' '}
                          <span className="font-medium" data-id="element-92">{activity.item}</span>
                        </p>
                      </div>
                    </div>
                    <span className="text-gray-500 text-sm" data-id="element-93">
                      {activity.time}
                    </span>
                  </div>)}
              </div>
            </div>
            <div data-id="element-94">
              <h4 className="text-lg font-medium text-gray-900 mb-3" data-id="element-95">
                KI-Vorschläge
              </h4>
              <div className="bg-blue-50 border border-blue-100 rounded-lg p-4" data-id="element-96">
                <p className="text-gray-800 mb-2" data-id="element-97">
                  <span className="font-medium" data-id="element-98">3 Belege</span> könnten
                  automatisch zugeordnet werden
                </p>
                <button className="text-blue-600 font-medium hover:underline" data-id="element-99">
                  Jetzt prüfen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};